import { Component } from '@opten/gin-tonic/helpers/compiler';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

@Component({ className: 'js-nav-visibility' })
export class NavVisibilityComponent {
	constructor(private element: HTMLElement) {
		const height = getComputedStyle(document.documentElement).getPropertyValue('--nax-height');

		gsap.registerPlugin(ScrollTrigger);
		ScrollTrigger.create({
			start: `top -${height}`,
			end: 99999,
			toggleClass: { className: 'is-hidden', targets: '.js-nav-visibility' }
		});
	}
}
